export const blockIconsPhotoandimagePhotoNew = (
	<span className='material-symbols-outlined'>photo</span>
);
